import { useEffect, useRef, useState } from 'react';
import { StreamChat } from 'stream-chat';

import { UserData } from '@bizzabo/entities';
import { instanaReportError } from '@bizzabo/instana-api';
import { config } from '@bizzabo/entities';

import connectUser from './user';

const useChatInstance = (
    eventId: number,
    user: UserData,
    accountId: number,
    isJoinChannelAsync = false
) => {
    const [chatClient, setChatClient] = useState(null);
    const isCalled = useRef(false);

    const initChat = async () => {
        if (isCalled.current) {
            return;
        }
        isCalled.current = true;
        try {
            const client = StreamChat.getInstance(config.getStreamKey);
            await connectUser(client, eventId, user, accountId, isJoinChannelAsync);
            setChatClient(client);
        } catch (error) {
            instanaReportError({ error });
        }
    };

    useEffect(() => {
        return () => {
            chatClient?.disconnectUser();
        }; //eslint-disable-next-line
    }, [eventId, user?.id]);

    return { initChat, client: chatClient };
};

export default useChatInstance;
